import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import { buildDefaultStatsPath } from '../hooks/useFilters';

/**
 * Catch-all route. Sends signed-in users back to the dashboard rather than
 * bouncing everyone to the login screen.
 */
export const NotFound = () => {
  const token = useAppSelector((state) => state.auth.token);
  return <Navigate to={token ? buildDefaultStatsPath() : '/auth'} replace />;
};
